import styles from "./input.module.css";

const Input = ({
  label,
  placeholder,
  type = "text",
  name,
  register,
  validation = {},
  error,
  rightSlot,
  disabled = false,
    readOnly = false, 
    
}) => {
  const isMobileField = name === "mobile";
  const isEmailField = name === "email";

  return (
    <div className={styles.inputGroup}>
      {label && <label className={styles.label}>{label}</label>}

      <div className={styles.inputWrapper}>
     <input
  {...register(name, validation)}
  className={`${styles.input} ${
    (isMobileField || isEmailField) ? styles.greenInput : ""
  }`}
  placeholder={placeholder}
  type={type}
  maxLength={isMobileField ? 10 : undefined}
  inputMode={isMobileField ? "numeric" : undefined}
  disabled={disabled}
  readOnly={readOnly}
  pattern={
    isMobileField
      ? "[0-9]*"
      : isEmailField
      ? "[a-zA-Z0-9@._-]+"
      : undefined
  }
  onInput={
    isMobileField
      ? (e) => {
          e.target.value = e.target.value
            .replace(/[^0-9]/g, "")
            .slice(0, 10);
        }
      : isEmailField
      ? (e) => {
          e.target.value = e.target.value.replace(
            /[^a-zA-Z0-9@._-]/g,
            ""
          );
        }
      : undefined
  }
/>

        {rightSlot && <div className={styles.rightSlot}>{rightSlot}</div>}
      </div>

      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
};

export default Input;
